<template>
  <div>
    <v-container fluid fill-height class="pa-0">
      <v-hover v-slot:default="{ hover }">
        <v-carousel
          :cycle="hover ? false : true"
          hide-delimiters
          :show-arrows="false"
          height="calc(75vh - 80px)">
          <v-carousel-item
            v-for="(slide, i) in headerlist"
            :key="i"
            :lazy-src="require('../assets/default.jpg')"
            :src="slide.urlpic">
            <v-container
              fill-height
              fluid
              pa-0 ma-0
              style="background-color: rgba(0,0,0,0.3);">
              <v-container class="pa-0">
                <v-layout
                  fill-height>
                  <v-flex
                    xs12
                    :align-self-end="!$vuetify.breakpoint.smAndDown"
                    :align-self-center="$vuetify.breakpoint.smAndDown">
                    <v-card
                      rounded="lg"
                      color="transparent"
                      flat>
                      <v-card-text :class="$vuetify.breakpoint.smAndDown ? 'text-center' : 'text-left'">
                        <div v-if="slide.judul_berita === ''">
                          <h3 class="white--text text-md-h6">Tempat belajar daring?</h3>
                          <h2 class="white--text text-md-h4 mb-2">e-Learning PNB</h2>
                          <p class="mb-8">e-Learning PNB adalah tempat lengkap untuk kegiatan belajar mengajar Anda secara daring.</p>
                          <v-btn
                            outlined
                            class="yellow--text"
                            :to="{ name: 'Register', query: { tab: 'mahasiswa' } }">
                            Join now
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-hover>
    </v-container>
    <v-container class="my-5">
      <v-row>
        <v-col cols="12" md="12">
          <h2 class="text-md-h4 font-weight-bold text-center">
            Panduan singkat
          </h2>
          <v-tabs
            class="mt-5 font-weight-bold"
            v-model="panduan"
            centered
            show-arrows>
            <v-tab href="#get-account">Mendapatkan Akun</v-tab>
            <v-tab href="#login-system">Masuk Sistem</v-tab>
            <v-tab href="#manual-book">Buku Panduan</v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="panduan" class="pa-3">
            <v-tab-item value="get-account">
              <v-timeline align-top dense>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Pilih menu SIGN UP</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Buka website e-Learning PNB, kemudian pilih menu <v-btn x-small tile color="primary" :to="{ name: 'Register' }">Sign Up</v-btn></p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Pilih form yang sesuai</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>
                        <ul>
                          <li>Pilih tab/form mahasiswa untuk pendaftaran akun mahasiswa</li>
                          <li>Pilih tab/form dosen untuk pendaftaran akun dosen</li>
                        </ul>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Isi data sesuai form yang dipilih</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>
                        <ul>
                          <li>Untuk mahasiswa: nama depan, nama belakang, NIM, e-mail aktif, dan password</li>
                          <li>Untuk mahasiswa: nama depan, nama belakang, NIP, e-mail aktif, dan password</li>
                          <li>Kemudian tekan tombol SIGN UP</li>
                        </ul>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Email verifikasi</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>
                        Jika berhasil, sistem akan mengirimkan email verifikasi akun ke email yang didaftarkan
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Aktivasi akun</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>
                        <ul>
                          <li>Cek email, kemudian klik tombol 'Activating My Account'</li>
                          <li>Pengguna akan diarahkan ke halaman aktivasi akun.</li>
                          <li>Jika aktivasi berhasil, sistem akan menampilkan pesan berhasil dan tombol SIGN IN.</li>
                        </ul>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="login-system">
              <v-timeline align-top dense>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Pilih menu Log In</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Buka website e-Learning PNB, kemudian pilih menu <v-btn x-small tile color="primary" :to="{ name: 'Login' }">Log In</v-btn></p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="blue"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="blue"
                    dark>
                    <v-card-title class="title py-3">Email dan password</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>
                        <ul>
                          <li>Masukan email dan password sesuai dengan email dan password yang didftarkan.  </li>
                          <li>Kemudian tekan tombol LOG IN untuk masuk ke sistem.</li>
                          <li>Jika berhasil pengguna akan diarahkan ke halaman list kelas yang dimiliki pengguna.</li>
                        </ul>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="manual-book">
              <div class="text-center">
                <object
                  :data="'/img/usermanual-el.pdf'"
                  type="application/pdf"
                  class="pdf-embed-custom">
                  <p>
                    Web browser anda tidak memiliki PDF plugin.<br>
                    Sebaliknya anda dapat download buku panduan pada tautan berikut:<br>
                    <a target="_blank" :href="'/img/usermanual-el.pdf'">
                      Download
                    </a>
                  </p>
                </object>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <!-- dialog event -->
    <v-dialog
      v-model="dmodal.event"
      max-width="700px"
      scrollable
      persistent>
      <v-card
        flat
        tile>
        <v-card-title>
          Upcoming Events!
          <v-spacer></v-spacer>
          <v-icon class="float-right class-cursor" color="red" @click="dmodal.event = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-hover v-slot:default="{ hover }">
            <v-carousel
              :cycle="hover ? false : true"
              :hide-delimiters="$vuetify.breakpoint.smAndDown"
              :show-arrows="!$vuetify.breakpoint.smAndDown"
              height="auto"
              show-arrows-on-hover>
              <v-carousel-item
                v-for="(slide, i) in newslist"
                :key="i"
                :lazy-src="require('../assets/default.jpg')"
                :src="slide.urlpic">
                <v-container
                  fill-height
                  fluid
                  style="background-color: rgba(0,0,0,0.5);">
                  <v-layout
                    fill-height>
                    <v-flex
                      xs12
                      :align-self-baseline="!$vuetify.breakpoint.smAndDown"
                      :align-self-center="$vuetify.breakpoint.smAndDown">
                      <v-card
                        rounded="lg"
                        color="transparent"
                        flat
                        class="mt-md-12">
                        <v-card-text
                          :class="'text-center'">
                          <div>
                            <h3 class="white--text text-md-h5" v-text="slide.judul_berita"></h3>
                            <div class="mb-6 mt-1">
                              <v-chip
                                small
                                color="error">
                                <v-icon left small>
                                  mdi-calendar-range
                                </v-icon>
                                {{ slide.tgl_berita }} {{ slide.type_berita === 'event' ? ' ~ ' + slide.tgl_end : '' }}
                              </v-chip>
                            </div>
                            <v-btn
                              outlined
                              dark
                              class="text-capitalize"
                              :to="{ name: 'NewsDetail', query: { berita: slide.id_berita } }">
                              more info
                              <v-icon
                                small
                                right
                                dark>
                                mdi-arrow-right
                              </v-icon>
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-carousel-item>
            </v-carousel>
          </v-hover>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import Job from '../components/Job.vue';
import { mapState } from 'vuex';
import { priceFromat } from '@/plugins/utils';

export default {
  name: 'Landing',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    newslist: [],
    listlocation: ['BADUNG', 'DENPASAR', 'GIANYAR', 'TABANAN'],
    companylist: [],
    categorylist: [],
    statistic: {},
    panduan: null,
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      keyword: '',
      location: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    slidecompany: null,
    slidermd: 0,
    listslide: [
      {
        text: '',
        url: '',
        img: require('./../assets/hero-image-man.jpeg'),
      },
      {
        text: 'Virtual Job Fair',
        url: 'https://bit.ly/VJFpnb20',
        img: require('./../assets/virtualjobfair.jpg'),
      },
    ],
    dmodal: {
      event: false,
    },
    onboarding: 0,
    headerlist: [
      {
        id_berita: '',
        judul_berita: '',
        urlpic: require('./../assets/bg.jpg'),
      },
    ],
  }),
  mounted() {
    // this.getBerita();
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  filters: {
    // For filter render
    rupiahformat(value) {
      if (!value) {
        return '';
      } else {
        return priceFromat(value, 'Rp');
      }
    },
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getBerita() {
      this.newslist = [];
      this.axios
        .get(
          this.api + '/public/event',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              resdata.data.forEach((element) => {
                if (element.pic_berita) {
                  element.urlpic = this.api + '/upload/news/' + element.pic_berita;
                } else {
                  element.urlpic = require('../assets/default.jpg');
                }
                this.newslist.push(element);
              });
              // console.log(this.newslist);
              if (this.newslist.length > 0) {
                this.eventDialog(true);
              } else {
                this.eventDialog(false);
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
    eventDialog(show) {
      this.dmodal.event = show;
    },
    next() {
      this.onboarding = this.onboarding + 1 === this.newslist.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.newslist.length - 1 : this.onboarding - 1;
    },
  },
  components: {
    Alertsp,
    Job,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ui-paralax-style{
    height: auto !important;
    /* min-height: 250px; */
  }
  .pdf-embed-custom{
    width: 850px;
    max-width: 100%;
    height: 100vh;
    margin: auto;
  }
</style>
